export default "__VITE_ASSET__da2f6958__"